module.exports = __webpack_public_path__ + "static/media/Wenqian Yan.e791f389.png";